module.exports = __webpack_public_path__ + "img/01d See_651px.2824497d.jpg";